import request from '../utils/request'
const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/packmap'
 
export function logout () {
  return request({
    url: baseUrl + '/lcmanager/logout',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/logout.js